/**
 * OCT-16164 - SSE fans every domain event out to every user connected to the
 * workspace. The bulk-approve bookend events (`invoice_bulk_approve_started`,
 * `invoice_bulk_approve_completed`, `invoice_bulk_sync_completed`) describe
 * one user's batch, so their toasts belong to that user only: the server
 * stamps the triggering user's id on the payload as `userId`.
 *
 * Returns true only when the payload names the signed-in user. A payload with
 * no `userId`, or no signed-in user yet, is not shown - a toast about someone
 * else's batch is worse than a missing one (the bell row still carries the
 * outcome for its owner).
 */
export function isOwnBulkEvent(
  payload: Record<string, unknown>,
  currentUserId: string | null | undefined,
): boolean {
  const triggeredBy = payload.userId;
  return typeof triggeredBy === "string" && !!currentUserId && triggeredBy === currentUserId;
}
